import _ from 'underscore';

export const AssetsReducerActionType = {
  SetAssetsData: 'ACTION_TYPE_SET_ASSETS_DATA',
  AddAssetsData: 'ACTION_TYPE_ADD_ASSETS_DATA',
  ResetAssetsData: 'ACTION_TYPE_RESET_ASSETS_DATA',
  RenameAssetData: 'ACTION_TYPE_RENAME_ASSET_DATA',
};

export const AssetsReducerActions = {
  setAssetsData: ({
    assets, ...rest
  }) => ({
    actionType: AssetsReducerActionType.SetAssetsData,
    assets,
    ...rest,
  }),

  addAssetsData: ({
    assets, windowIndex, windowSize, ...rest
  }) => ({
    actionType: AssetsReducerActionType.AddAssetsData,
    assets,
    pageIndex: windowIndex,
    pageSize: windowSize,
    ...rest,
  }),

  resetAssetData: () => ({
    actionType: AssetsReducerActionType.ResetAssetsData,
  }),

  renameAssetData: ({
    assetId, name,
  }) => ({
    actionType: AssetsReducerActionType.RenameAssetData,
    assetId,
    name,
  }),
};

export const InitialReducerState = {
  assets: [],
};

export const defaultReducer = (state, action) => {
  const { actionType, ...actionData } = action || {};
  switch (actionType) {
    case AssetsReducerActionType.SetAssetsData:
    {
      const { assets, ...rest } = actionData;
      const newAssets = [...assets];
      return { ...state, ...rest, assets: newAssets };
    }

    case AssetsReducerActionType.AddAssetsData:
    {
      const {
        assets, pageIndex, pageSize, ...rest
      } = actionData;
      const newAssets = [...state.assets];
      const startIdx = pageIndex * pageSize;
      _.forEach(assets, (asset, idx) => {
        newAssets[startIdx + idx] = asset;
      });
      return { ...state, ...rest, assets: newAssets };
    }

    case AssetsReducerActionType.ResetAssetsData:
      return InitialReducerState;

    case AssetsReducerActionType.RenameAssetData:
    {
      const { assetId, name } = actionData;
      const idx = _.findIndex(state.assets, asset => asset.id === assetId);
      if (idx >= 0 && state.assets[idx].name !== name) {
        const newAsset = { ...state.assets[idx], name };
        const newAssets = [...state.assets];
        newAssets.splice(idx, 1, newAsset);
        return { ...state, assets: newAssets };
      }
      return state;
    }

    default:
      return state;
  }
};

// used with SequenceAssetsWindowManager, which has sourceName and indexOffset in the window object
export const sequenceWindowReducer = (state, action) => {
  const { actionType, ...actionData } = action || {};
  switch (actionType) {
    case AssetsReducerActionType.AddAssetsData:
    {
      const {
        assets, pageIndex, pageSize, indexOffset = 0, ...rest // sourceName,
      } = actionData;
      const newAssets = [...state.assets];
      const startIdx = indexOffset + (pageIndex * pageSize);
      _.forEach(assets, (asset, idx) => {
        newAssets[startIdx + idx] = asset;
      });
      return { ...state, ...rest, assets: newAssets };
    }

    default:
      return defaultReducer(state, action);
  }
};
